/* Utilities */
import { delegateMSTEvent } from '~/src/utils/analytics';
import analyticsService from '~/src/services/analytics';

/* Events */
const events = {
  downloadDocument: (args) => {
    const [document] = args;
    analyticsService.track('Document Downloaded', {
      title: document.title,
      documentId: document.id,
    });
  },

  setRelatedContactId: (args) => {
    const [contactId, card, project] = args;

    if (contactId) {
      const document = project.documents[0];

      analyticsService.track('Document Contact Attached', {
        contactId,
        documentId: document.id,
        cardLabel: card.name,
        cardType: card.type,
        cardId: card.id,
      });
    }
  },

  createDocSet: (args) => {
    const [templateIds, name, matterId] = args;

    analyticsService.track(
      templateIds.length == 1 ? 'Document Created' : 'Document Set Created',
      {
        title: name,
        projectName: name,
        matterId,
        templateIds: JSON.stringify(templateIds),
      },
    );
  },

  updateProject: (args) => {
    const [projectId, projectData] = args;

    analyticsService.track('Document Set Metadata Updated', {
      title: projectData.title,
      projectId,
    });
  },

  deleteProject: (args) => {
    const [projectId] = args;

    analyticsService.track('Document Set Removed', {
      projectId,
    });
  },
};

const flowReturnEvents = {
  publish: (args) => {
    const [project] = args;
    let cardCount = 0;
    let fieldCount = 0;
    let pageCount = 0;
    let documentCount = 0;

    project.cards.forEach((card) => {
      cardCount += 1;
      fieldCount += card.fields.length;
    });

    project.documents.forEach((document) => {
      documentCount += 1;
      pageCount += document.pages.length;
    });

    let eventProps = {
      projectName: project.name,
      projectId: project.id,
      matterId: project.matterId,
      cards: project.cards.toJSON(),
      cardCount,
      fieldCount,
      pageCount,
      documentCount,
    };

    let eventName = '';
    if (project.isDocumentSet()) {
      const templateIds = project.documents.map(
        (document) => document.template_docid,
      );

      eventName = 'Document Set Generated';
      eventProps = {
        ...eventProps,
        title: project.name,
        templateIds: JSON.stringify(templateIds),
      };
    } else {
      const document = project.documents[0];
      eventName = 'Document Generated';
      eventProps = {
        ...eventProps,
        title: document.title,
        documentId: document.id,
        templateId: document.template_docid,
      };
    }

    analyticsService.track(eventName, eventProps);
  },

  exportDocSet: (args) => {
    const [project] = args;
    let cardCount = 0;
    let fieldCount = 0;
    let pageCount = 0;
    let documentCount = 0;

    if (project.cards) {
      project.cards.forEach((card) => {
        cardCount += 1;
        fieldCount += card.fields.length;
      });
    }

    let templateIds = [];
    if (project.documents) {
      project.documents.forEach((doc) => {
        documentCount += 1;
        pageCount += doc.pages.length;
      });
      templateIds = project.documents.map(
        (document) => document.template_docid,
      );
    }

    analyticsService.track('Document Set Downloaded', {
      title: project.name,
      projectName: project.name,
      projectId: project.id,
      matterId: project.matterId,
      cards: project.cards && project.cards.toJSON(),
      cardCount,
      fieldCount,
      pageCount,
      documentCount,
      templateIds: JSON.stringify(templateIds),
    });
  },
};

export default (call, rootStore) => {
  return delegateMSTEvent(call, rootStore, { events, flowReturnEvents });
};
